import axios from 'axios'
import { message } from 'ant-design-vue';
import { VueAxios } from './axios'
// const responesContentTypeDownload = ['application/octet-stream', 'application/octet-stream;charset=UTF-8', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8']
const resSucCode = ['200000']
// import config from '@/config/index'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  }
  // timeout: 60000// 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  console.log(error, 'errorerrorerrorerrorerrorerrorerrorerror')
  if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
    message.error({
      message: '错误提示',
      description: '请求超时'
    })
    return Promise.reject(error)
  }
  return Promise.reject(error)
}
// request interceptor
request.interceptors.request.use(config => {
  // console.log(config, 'confg')
  // const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  // if (token) {
  //   config.headers['Authorization'] = token
  // }
  Object.assign(config, {
    showErrorMsg: config.showErrorMsg === undefined ?  true : config.showErrorMsg
  })
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  console.log(resSucCode.includes(response.data.code))
  if (response && !resSucCode.includes(response.data.code) && response.config.showErrorMsg) {
    message.error(response.data.msg || '系统错误')
    return Promise.reject(new Error(JSON.stringify(response.data)))
  }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
